<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card flat>
        <v-row class="hidden-sm-and-down">
            <v-col cols="12" sm="6" class="pr-0">
                <v-card-title class="d-flex title justify-center pa-0">{{ $t('condition') }}</v-card-title>
            </v-col>
            <v-col cols="12" sm="6" class="pr-0">
                <v-card-title class="d-flex title justify-center pa-0">{{ $t('discount') }} (%)</v-card-title>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col cols="12" sm="12" class="pr-0 pt-6">
                <v-form v-model="validated1">
                    <v-row class="d-flex">
                        <v-col cols="12" sm="6" class="px-10 py-sm-0 ">
                            <div class="d-flex align-baseline">
                                <v-checkbox
                                        @change="checkBoxChange"
                                        v-model="paymentPolicy.prepayment.prepaymentCheckbox"
                                        hide-details
                                        :label="$t('Prepayment')+ ' '+ '(100%)'"
                                        color="orange lighten-2"
                                        class="shrink mr-2 mt-0"
                                ></v-checkbox>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" class="px-10 py-sm-0">
                            <v-row class="d-flex justify-center">
                                <v-col cols="12" sm="3" class="px-4 pa-sm-0">
                                    <v-text-field
                                            @input="checkBoxChange"
                                            :disabled="!paymentPolicy.prepayment.prepaymentCheckbox"
                                            v-model="paymentPolicy.prepayment.discount"
                                            :label="$t('discount') + ' '+ '(%)'"
                                            class="pa-0 ma-0"
                                            color="orange lighten-2"
                                            type="number"
                                            min="1"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
        <div v-for="i in conditionsCount" :key="i">
            <v-divider></v-divider>
            <v-form v-model="validated2">
                <v-row class="d-flex">
                    <v-col cols="12" sm="6" class="px-10 pr-sm-0">
                        <div class="d-flex justify-center align-center">
                            <v-checkbox
                                    @change="itemChange(i)"
                                    v-model="paymentPolicy.credits[i - 1].creditCheckbox"
                                    hide-details
                                    :label="$t('credit')"
                                    color="orange lighten-2"
                                    class="shrink mr-2 mt-0"
                            ></v-checkbox>
                            <div class="d-flex flex-wrap">
                                <div class="d-flex align-baseline">
                                    <v-text-field
                                            @input="itemChange(i)"
                                            :disabled="!paymentPolicy.credits[i - 1].creditCheckbox"
                                            v-model="paymentPolicy.credits[i - 1].creditPrepayment"
                                            :label="$t('balancePart') + ' '+'%'"
                                            color="orange lighten-2"
                                            class="pa-0 px-2 "
                                            type="number"
                                            min="1"
                                    ></v-text-field>
                                    <v-text-field
                                            @input="itemChange(i)"
                                            :disabled="!paymentPolicy.credits[i - 1].creditCheckbox"
                                            v-model="paymentPolicy.credits[i - 1].creditTerm"
                                            :label="$t('numberOfDays')"
                                            color="orange lighten-2"
                                            class="pa-0 px-2 "
                                            type="number"
                                            min="1"
                                    ></v-text-field>
                                </div>
                                <div class="d-flex align-baseline">
                                    <v-text-field
                                            @input="itemChange(i)"
                                            :disabled="!paymentPolicy.credits[i - 1].creditCheckbox"
                                            v-model="paymentPolicy.credits[i - 1].creditRest"
                                            :label="$t('creditPart') + ' '+'%'"
                                            color="orange lighten-2"
                                            class="pa-0 px-2 "
                                            type="number"
                                            min="1"
                                    ></v-text-field>
                                    <v-menu
                                            v-model="paymentPolicy.credits[i - 1].creditDateMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    :disabled="!paymentPolicy.credits[i - 1].creditCheckbox"
                                                    v-model="dateText[i - 1]"
                                                    readonly
                                                    v-on="on"
                                                    :label="$t('selectDate')"
                                                    color="orange lighten-2"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                @change="itemChange(i)"
                                                v-model="paymentPolicy.credits[i - 1].prepaymentTo"
                                                show-current
                                                @input="paymentPolicy.credits[i - 1].creditDateMenu = false"
                                                :locale="language"
                                                header-color="orange lighten-2"
                                                color="orange lighten-2"
                                                :min="currentDate"
                                        ></v-date-picker>
                                    </v-menu>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex">
                            <p class="pr-3 ma-0 body-2">{{ $t('provision') }}</p>
                            <div>
                                <v-checkbox
                                        v-for="check in guarantiesItems"
                                        :key="check.id"
                                        :value="check.id"
                                        :label="check.name"
                                        @change="itemChange(i)"
                                        :disabled="!paymentPolicy.credits[i - 1].creditCheckbox"
                                        v-model="paymentPolicy.credits[i - 1].guaranties"
                                        hide-details
                                        color="orange lighten-2"
                                        class="shrink mr-2 mt-0"
                                ></v-checkbox>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" class="px-10 d-flex align-center">
                        <v-row class="d-flex justify-center">
                            <v-col cols="12" sm="3" class="px-4 pa-sm-0">
                                <v-text-field
                                        @input="itemChange(i)"
                                        :disabled="!paymentPolicy.credits[i - 1].creditCheckbox"
                                        v-model="paymentPolicy.credits[i - 1].discount"
                                        :label="$t('discount') + ' '+ '(%)'"
                                        class="pa-0 ma-0"
                                        color="orange lighten-2"
                                        type="number"
                                        min="1"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>
            <div class="d-flex justify-center pb-4">
                <v-btn
                        dark
                        class="text--main-yellow"
                        text
                        @click="addString"
                        v-if="conditionsCount === i"
                >
                    {{ $t('addCondition') }}
                </v-btn>
                <v-btn
                        v-if="conditionsCount > 1"
                        text
                        color="error"
                        @click="deleteString(i - 1)"
                >
                    {{ $t('delete') }}
                </v-btn>
            </div>
        </div>
    </v-card>
</template>

<script>

    export default {
        name: "Payment",
        props: ['initialPaymentPolicy', 'guaranteeData'],
        data() {
            return {
                validated1: false,
                validated2: false,
                conditionsCount: 1,
                paymentPolicy: {
                    prepayment: {
                        prepaymentCheckbox: false,
                        discount: null,
                    },
                    credits:[],
                },
                dateText: [],
                guarantiesItems: [],
                currentDate: new Date().toISOString().substr(0, 10),
            }
        },
        computed: {
            language() {
                if (this.$store.state.language.appLanguage === 'ua') {
                    return 'uk';
                }
                if (this.$store.state.language.appLanguage === 'ru') {
                    return 'ru';
                }
            }
        },
        methods: {
            addString() {
                this.paymentPolicy.credits.push(this.getDefaultPolicy());
                this.conditionsCount++;
            },
            deleteString(i) {
                this.conditionsCount--;
                this.paymentPolicy.credits.splice(i,1);
                this.itemChange(i);
            },
            checkBoxChange() {
                let isValid = true;
                const data = this.paymentPolicy.prepayment;

                if (!this.validatePrepayment(data)) {
                    isValid = false;
                }

                if(this.paymentPolicy.prepayment.prepaymentCheckbox === false) {
                    this.paymentPolicy.prepayment.discount = null;

                    isValid = true;
                    this.$emit('checkbox-change', isValid);
                }

                this.$emit('checkbox-change', {data, isValid});
            },
            itemChange(i) {
                const data = [];
                let isValid = true;

                if(this.paymentPolicy.credits[i - 1].prepaymentTo) {
                    this.dateText[i - 1] = this.paymentPolicy.credits[i - 1].prepaymentTo.split('-').reverse().join('.');
                }

                this.paymentPolicy.credits.forEach(item => {
                    if(this.validate(item))  {
                        data.push(item);
                    } else {
                        isValid = false;
                    }
                });

                const policy = this.paymentPolicy.credits;

                if(policy[i - 1].creditCheckbox === false) {
                    policy[i - 1].creditRest = null;
                    policy[i - 1].prepaymentTo = null;
                    policy[i - 1].creditPrepayment = null;
                    policy[i - 1].creditTerm = null;
                    policy[i - 1].guaranties = [];
                    policy[i - 1].discount = null;
                    this.dateText[i - 1] = null;

                    isValid = true;
                    this.$emit('list-change', isValid);
                }

                this.$emit('list-change', {data, isValid});
            },
            getDefaultPolicy() {
                return {
                    creditCheckbox: false,
                    creditRest: null,
                    prepaymentTo: null,
                    creditPrepayment: null,
                    creditTerm: null,
                    guaranties: [],
                    discount: null,
                }
            },
            validatePrepayment(data) {
                let valid = false;

                if(data.prepaymentCheckbox) {
                    if(data.discount) {
                        valid = true;
                    } else {
                        valid = false;
                    }
                }
                return valid;
            },
            validate(policy) {
                let valid = false;

                if(policy.creditCheckbox) {
                    if(policy.creditRest && policy.prepaymentTo && policy.creditPrepayment && policy.creditTerm && policy.discount) {
                        valid = true;
                    } else {
                        valid = false;
                    }
                }
                return valid;
            },
            setGuaranties() {
                if(this.guaranteeData.length) {
                    this.guarantiesItems = this.guaranteeData;
                }
            },
            setInitial() {
                if(!this.initialPaymentPolicy || !Object.keys(this.initialPaymentPolicy).length) {
                    return false;
                }

                if(Object.keys(this.initialPaymentPolicy.prepayment).length) {
                    this.paymentPolicy.prepayment = {
                        prepaymentCheckbox: true,
                        discount: this.initialPaymentPolicy.prepayment.discount
                    }
                }

                if(this.initialPaymentPolicy.credits.length) {
                    this.paymentPolicy.credits = this.initialPaymentPolicy.credits.map(item => {
                        item['creditCheckbox'] = true;
                        if(item.prepaymentTo)
                            this.dateText.push(item.prepaymentTo.split('-').reverse().join('.'));
                        return item;
                    });

                    this.conditionsCount = this.paymentPolicy.credits.length;
                }
            }
        },
        beforeMount() {
            this.setGuaranties();
            this.paymentPolicy.credits.push(this.getDefaultPolicy());
            this.setInitial();
        },
        watch: {
            initialPaymentPolicy: {
                handler() {
                    this.setInitial();
                },
                deep: true
            },
            guaranteeData: {
                handler() {
                    this.setGuaranties();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
